import React, {Component} from 'react'
import {LIST_SOURCE} from "../../helpers/filtersTable"
import {Select} from "antd"
import 'antd/lib/select/style/index.css'
import PropTypes from 'prop-types'

const {Option} = Select

class FilterSource extends Component {
    _handleChange = (value) => {
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        delete filters['before_id']
        delete filters['after_id']

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                source: value
            })
        }
    }

    render() {
        const {filters} = this.props
        const {source} = filters
        const field = 'source'

        return (
            <div className="FilterShippingCarrier mb-3 ml-3">
                <label className='font-weight-bold d-block'>Source</label>
                <Select
                    style={{width: 300}}
                    showArrow={true}
                    placeholder="Vui lòng chọn source"
                    defaultValue={source}
                    onChange={this._handleChange}
                    value={source}
                >
                    <Option value=''>All</Option>
                    {
                        LIST_SOURCE.map((option, index) => {

                            const {name, value} = option

                            return (value !== '' &&
                                <Option key={`${field}_${value}_${index + 1}`} value={value}>{name}</Option>)
                        })
                    }
                </Select>
            </div>
        )
    }
}

FilterSource.propTypes = {
    filters: PropTypes.object.isRequired,
    onChangeFilters: PropTypes.func.isRequired
}

export default FilterSource
